import React from 'react';
import { connect } from 'react-redux';
import { useRouter } from 'Hooks';
import { GeneralModal, Providers } from 'Components/utility';
const mapState = ({ nav: { location, initErrorStatus, queryString } }) => {
    return {
        initErrorStatus,
        queryString,
        location,
    };
};
const connector = connect(mapState);
const App = ({ initErrorStatus, queryString, location }) => {
    const { Component, props } = useRouter(location, queryString, initErrorStatus);
    return (React.createElement(Providers, null,
        React.createElement(Component, { ...props }),
        React.createElement(GeneralModal, null)));
};
export default connector(App);
